/** @jsxRuntime classic */
/** @jsx jsx */
import Redirect from '@bottlebooks/gatsby-theme-event/src/components/Redirect';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { jsx } from 'theme-ui';

export default function ProductRedirectPage({ params }) {
  const link = useLink();
  return <Redirect to={link.exhibitor(params)} replace />;
}
